export default __webpack_public_path__ + "static/media/vf-customer-added.0faa0d28.svg";